// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file tabgraph/v1/user.proto (package tabgraph.v1, syntax proto3)
/* eslint-disable */

// Package tabgraph.v1 defines the canonical data types and services for the
// tabgraph application.

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tabgraph/v1/user.proto.
 */
export const file_tabgraph_v1_user: GenFile = /*@__PURE__*/
  fileDesc("ChZ0YWJncmFwaC92MS91c2VyLnByb3RvEgt0YWJncmFwaC52MSLlAQoEVXNlchIKCgJpZBgBIAEoCRINCgVlbWFpbBgCIAEoCRIUCgxkaXNwbGF5X25hbWUYAyABKAkSJAoEcGxhbhgEIAEoDjIWLnRhYmdyYXBoLnYxLlVzZXIuUGxhbhIuCgpjcmVhdGVkX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIbChNzdWJzY3JpcHRpb25fYWN0aXZlGAYgASgIIjkKBFBsYW4SFAoQUExBTl9VTlNQRUNJRklFRBAAEg0KCVBMQU5fRlJFRRABEgwKCFBMQU5fUFJPEAJCR1pFZ2l0aHViLmNvbS9zdHJhdHVzc3R1ZGlvcy90YWJncmFwaC9iYWNrZW5kL2dlbi90YWJncmFwaC92MTt0YWJncmFwaHYxYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * User represents a registered tabgraph account.
 *
 * @generated from message tabgraph.v1.User
 */
export type User = Message<"tabgraph.v1.User"> & {
  /**
   * id is the unique user identifier, prefixed usr_<ksuid>.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * email is the user's primary email address.
   *
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * display_name is the user's chosen display name.
   *
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * plan indicates the user's current subscription tier.
   *
   * @generated from field: tabgraph.v1.User.Plan plan = 4;
   */
  plan: User_Plan;

  /**
   * created_at is when the account was first created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;

  /**
   * subscription_active reports whether the user's paid subscription (if
   * any) is in good standing. Sourced from the entitlements Checker
   * (backend/internal/entitlements); always true while billing runs in
   * stub mode. See docs/billing-architecture.md.
   *
   * @generated from field: bool subscription_active = 6;
   */
  subscriptionActive: boolean;
};

/**
 * Describes the message tabgraph.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_tabgraph_v1_user, 0);

/**
 * Plan enumerates the available subscription tiers.
 *
 * @generated from enum tabgraph.v1.User.Plan
 */
export enum User_Plan {
  /**
   * PLAN_UNSPECIFIED is the zero value; treat as unknown.
   *
   * @generated from enum value: PLAN_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * PLAN_FREE is the no-cost tier with session and save limits.
   *
   * @generated from enum value: PLAN_FREE = 1;
   */
  FREE = 1,

  /**
   * PLAN_PRO is the paid tier with expanded limits.
   *
   * @generated from enum value: PLAN_PRO = 2;
   */
  PRO = 2,
}

/**
 * Describes the enum tabgraph.v1.User.Plan.
 */
export const User_PlanSchema: GenEnum<User_Plan> = /*@__PURE__*/
  enumDesc(file_tabgraph_v1_user, 0, 0);

